import {Injectable} from '@angular/core';
import {UserCompanyList, UserList, UserQuery, UserRequest, UserResponse} from './entity/user.entity';
import {Observable} from 'rxjs';
import {ApiResponse, PaginationResponse,} from '../../base/repository/entity/base.entity';
import {HttpClient, HttpParams} from '@angular/common/http';
import {environment} from '../../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class UserRepository {
  constructor(private http: HttpClient) {
  }

  getUserCompany(): Observable<ApiResponse<UserCompanyList[]>> {
    return this.http.get<ApiResponse<UserCompanyList[]>>(
      `${environment.baseUrl}/company`
    );
  }

  getUser(
    query: UserQuery
  ): Observable<ApiResponse<PaginationResponse<UserList[]>>> {
    return this.http.get<ApiResponse<PaginationResponse<UserList[]>>>(
      `${environment.baseUrl}/user?${this.userQuery(query)}`
    );
  }

  getUserByUsername(
    username: string
  ): Observable<ApiResponse<UserResponse>> {
    return this.http.get<ApiResponse<UserResponse>>(
      `${environment.baseUrl}/user/${username}`
    );
  }

  createUser(request: UserRequest): Observable<ApiResponse<UserResponse>> {
    return this.http.post<ApiResponse<UserResponse>>(`${environment.baseUrl}/user/`, request);
  }

  updateUser(request: UserRequest): Observable<ApiResponse<UserResponse>> {
    return this.http.put<ApiResponse<UserResponse>>(`${environment.baseUrl}/user/${request.username}`, request);
  }

  deleteUser(username: string): Observable<ApiResponse<boolean>> {
    return this.http.patch<ApiResponse<boolean>>(`${environment.baseUrl}/user/delete/${username}`, {});
  }

  restoreUser(username: string): Observable<ApiResponse<boolean>> {
    return this.http.patch<ApiResponse<boolean>>(`${environment.baseUrl}/user/restore/${username}`, {});
  }

  private userQuery(query: UserQuery) {
    const params = new HttpParams()
      .set('limit', query.limit.toString())
      .set('page', query.page.toString())
      .set('q', query.q);

    return params.toString();
  }
}
